import Vue from "vue";

import { APPLY_TITLE, APPLY_TEMPLATE, APPLY_ERROR } from "@/store/actions.type";

import {
  SET_TITLE,
  SET_TEMPLATE,
  SET_ERROR,
  SET_TEMPLATE_PATH
} from "@/store/mutations.type";

const state = {
  title: "",
  template: "FauxContainer",
  error: "",
  blockedTemplateView: "",
  bounceTemplateView: "",
  meetingTemplateView: "",
  noMeetingTemplateView: "",
  sessionTemplateView: "",
  transportTemplateView: "",
  welcomeTemplateView: ""
};

const actions = {
  [APPLY_TITLE](context, payload) {
    context.commit(SET_TITLE, payload);
  },
  [APPLY_TEMPLATE](context, payload) {
    context.commit(SET_TEMPLATE, payload);
  },
  [APPLY_ERROR](context, payload) {
    context.commit(SET_ERROR, payload);
  }
};

const mutations = {
  [SET_TITLE](state, data) {
    state.title = data;
  },
  [SET_TEMPLATE](state, data) {
    state.template = data;
  },
  [SET_ERROR](state, data) {
    state.error = data;
  },
  [SET_TEMPLATE_PATH](state, data) {
    console.log("data is..");
    console.log(data);
    let templatePath = data.template;
    switch (templatePath) {
      case "templates/faux_marriott_gpns/":
        
        break;

      case "templates/innflux_final/":

        break;
    }
  }
};

const getters = {
  title(state) {
    return state.title;
  },
  template(state) {
    return state.template;
  },
  error(state) {
    return state.error;
  },
  blockedTemplateView(state) {
    return state.blockedTemplateView;
  },
  bounceTemplateView(state) {
    return state.bounceTemplateView;
  },
  meetingTemplateView(state) {
    return state.meetingTemplateView;
  },
  noMeetingTemplateView(state) {
    return state.noMeetingTemplateView;
  },
  sessionTemplateView(state) {
    return state.sessionTemplateView;
  },
  transportTemplateView(state) {
    return state.transportTemplateView;
  },
  welcomeTemplateView(state) {
    return state.welcomeTemplateView;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
